import { getEditorConcreteComponent } from '../../selector'

import { questions } from './constant'

export const getQuestionsComponents = () => {
	const periodsSelect = getEditorConcreteComponent(questions.periodsSelect.select)
	return {
		periodSelect: periodsSelect,
	}
}
